import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FestivalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"festival"}/>
}
